import { iconType } from 'app/common/ui-next/plain-icon'

const VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS = 'external_services' as const

const sections = {
  VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS,
}

export type Section = (typeof sections)[keyof typeof sections]
export default sections

export const availableSections: Array<Section> = [
  sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS,
]

export const defaultSection = sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS

export const sectionTitles: Record<Section, string> = {
  [sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS]: 'Интеграция со внешними сервисами',
}

export const sectionIcons: Record<Section, string> = {
  [sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS]: iconType.GENERAL_SETTINGS,
}
